// extracted by mini-css-extract-plugin
export default {"description":"Heading_description__OxYcQ","heading":"Heading_heading__cdx+l"};